import { Avatar, Box, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { stringAvatar } from 'components/DataGrid/gridOperators'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'

interface RenderContactNameCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
  handleRowClick: (row: GridRenderCellParams) => void
}

const RenderContactNameCell: FC<RenderContactNameCellProps> = ({ params, densityStyles, handleRowClick }) => {
  const { rowNode, row: _row, value } = params
  const row = params.row
  const { PK: _PK, isParent } = row
  const contacts_uuid = row?.contacts_uuid
  const isChild = !isParent
  const depth = rowNode?.depth ?? 0
  const indent = depth * 20

  const contact = _row ?? {}
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        pl: isChild ? `${indent}px` : densityStyles.padding,
        pt: densityStyles.padding,
        pb: densityStyles.padding,
        pr: densityStyles.padding,
        gap: densityStyles.gap,
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={() => handleRowClick(row)}
    >
      <>
        {/* avatar only on parent rows */}
        {contact?.photoUrl ? (
          <Avatar
            src={contact.photoUrl}
            sx={{
              width: densityStyles.avatarSize,
              height: densityStyles.avatarSize,
              objectFit: 'cover',
              objectPosition: 'center',
              ml: 1,
            }}
            alt={value}
          />
        ) : (
          <Avatar
            {...stringAvatar(value, densityStyles)}
            sx={{
              backgroundColor: 'rgb(114, 229, 218)',
              width: densityStyles.avatarSize,
              height: densityStyles.avatarSize,
              ml: 1,
            }}
            alt={value}
          />
        )}

        {/* finally, the row label */}
        <Typography
          sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            fontSize: densityStyles.fontSize,
            fontWeight: isParent ? 600 : 400,
            ml: isParent ? 1 : 0,
            color: row?.isOrgTask ? 'text.highlight' : 'text.primary',
          }}
        >
          {value}
        </Typography>
      </>
    </Box>
  )
}

export default RenderContactNameCell
